import Box from '../../UI/Box/Box'
import SideMenuLink from './SideMenuLink'
import {SideMenuLinkProps} from './types'

export const advisorMenuContent: SideMenuLinkProps[] = [
  {href: '/hesabim/danisman', iconName: 'home', text: 'Anasayfa', IsNew: false},
  {
    href: '/hesabim/danisman/takvimim',
    iconName: 'calendar',
    text: 'Takvimim',
    IsNew: false,
  },
  {
    href: '/hesabim/danisman/danisanlarim',
    iconName: 'group',
    text: 'Danışanlarım',
    IsNew: false,
  },
  {
    href: '/hesabim/danisman/paket-satislarim',
    iconName: 'chart',
    text: 'Paket Satışlarım',
    IsNew: false,
  },
  {
    href: '/hesabim/danisman/profilim',
    iconName: 'profile',
    text: 'Profilim',
    IsNew: false,
  },
  {
    href: '/hesabim/danisman/sponsor',
    iconName: 'upChart',
    text: 'Sponsorluk',
    IsNew: true,
  },
  {
    href: '/hesabim/danisman/siparisler',
    iconName: 'shoppingCart',
    text: 'Siparişlerim',
    IsNew: false,
  },
  {
    href: '/hesabim/danisman/odemeler',
    iconName: 'wallet',
    text: 'Ödemeler',
    IsNew: false,
  },
  {
    href: '/hesabim/danisman/kupon-olustur',
    iconName: 'coupon',
    text: 'Kupon Oluştur',
    IsNew: false,
  },
  {
    href: '/hesabim/danisman/blog-yaz',
    iconName: 'blogSide',
    text: 'Blog Yaz',
    IsNew: false,
  },
]

export const clientMenuContent: SideMenuLinkProps[] = [
  {href: '/hesabim/randevularim', iconName: 'calendar', text: 'Randevularım'},
  {href: '/hesabim/mesajlarim', iconName: 'message', text: 'Mesajlar'},
  {href: '/hesabim/siparisler', iconName: 'shoppingCart', text: 'Siparişlerim'},
  {
    href: '/hesabim/bildirim-ayarlari',
    iconName: 'notification',
    text: 'Bildirim Ayarlarım',
  },
  {href: '/hesabim/ayarlar', iconName: 'settings', text: 'Ayarlar'},
  {href: '/hesabim/yardim-hatti', iconName: 'profile', text: 'Destek Hattım'},
]

const createLinks = (list: SideMenuLinkProps[]) => {
  return (
    <Box className="flex-col gap-2">
      {list.map((element, i) => (
        <SideMenuLink {...element} key={i} />
      ))}
    </Box>
  )
}

export const sideMenuClientContent = createLinks(clientMenuContent)

export const sideMenuConsultantContent = createLinks(advisorMenuContent)
